import { useState } from 'react'
import { Grid2 as Grid } from '@mui/material'
import UserCard from './UserCard'
import ProfileCard from '../basicDetails/ProfileCard'
import BasicDetailsCard from '../basicDetails/BasicDetailsCard'
import ClaimProgressCard from './ClaimProgressCard'

function Members() {
  const [openProfile, setOpenProfile] = useState(false)
  const members = [1, 2, 3, 4]
  return (
    <Grid container direction={'row'} spacing={1.5} padding={2}>
      {!openProfile ? (
        <>
          {members?.map((item, index) => {
            return (
              <Grid size={{ xs: 3 }} key={index}>
                <UserCard setOpenProfile={setOpenProfile} />
              </Grid>
            )
          })}
        </>
      ) : (
        <>
          <Grid size={{ xs: 12, sm: 12, lg: 3, md: 3, xl: 3 }}>
            <ProfileCard actions={true} />
          </Grid>
          <Grid size={{ xs: 12, sm: 12, lg: 9, md: 9, xl: 9 }}>
            <BasicDetailsCard />
          </Grid>
          <Grid size={{ xs: 12, sm: 12, lg: 12, md: 12, xl: 12 }}>
            <ClaimProgressCard />
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default Members
